import { Button, Modal } from "react-bootstrap";
import { useApp } from "./Behaviors/app";
import { version } from "./autobuild_version";
import "react-toastify/dist/ReactToastify.css";

export function AppVersion() {
    const serverVersion = useApp().version;

    const outdated = serverVersion !== undefined && serverVersion !== null && serverVersion.trim() !== version;
    return (
        <div id="info">{/*{version}*/}
            <Modal show={outdated} onHide={() => window.location.reload()} centered={true}>
                <Modal.Header>
                    <Modal.Title>New Version Available</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <p>A new version of AIT is available. This view will automatically be refreshed.</p>
                </Modal.Body>

                <Modal.Footer>
                    <Button onClick={() => window.location.reload()} variant="primary">Update</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
